module.exports = __webpack_public_path__ + "static/img/point_icon_10.73cb485c.svg";